module.exports = __webpack_public_path__ + "static/media/swissbtdp.86b6d739.jpg";